import MsalProvider from '@tracker/shared/src/Auth/Msal';
import React from 'react';
import Main from './Main';

const App : React.FC = () => (
    <MsalProvider>
        <Main/>
    </MsalProvider>
);

export default App;
